import { render } from "./ChildComponent.vue?vue&type=template&id=544c571d&scoped=true"
import script from "./ChildComponent.vue?vue&type=script&lang=js"
export * from "./ChildComponent.vue?vue&type=script&lang=js"

import "./ChildComponent.vue?vue&type=style&index=0&id=544c571d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544c571d"]])

export default __exports__